import React, { CSSProperties } from 'react';

type Props = {
  name: string;
  type: string;
  value: any;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
};

const Input = (props: Props) => (
  // wrapped in label for a11y. testing library needs this to access password inputs
  // https://github.com/testing-library/dom-testing-library/issues/567
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  <label id={props.name}>
    <span style={{ display: 'none' }}>{props.name}</span>
    <input
      aria-labelledby={props.name}
      name={props.name}
      type={props.type}
      style={styles}
      value={props.value}
      onChange={props.onChange}
      placeholder={props.placeholder}
    />
  </label>
);

const styles: CSSProperties = {
  width: '100%',
  margin: 0,
  paddingLeft: 10,
};

// TODO CONFIGURE TYPE DEFINITIONS FOR CSSINJS
// const styles = cssInJS({
//   input: {
//     margin: 0,
//     width: '100%',
//     paddingLeft: 10
//   }
// })

export default Input;
